import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider} from '@mui/material'
import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {hideSubmitDialog} from '../../store/slice/dialogSlice'
import {LoadingButton} from '@mui/lab'

const SubmitDialog = ({handleSubmit, text, loadingSubmit, hideSave}) => {
    const open = useSelector((state) => state.dialogSlice.submitDialog)
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(hideSubmitDialog())
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Submit</DialogTitle>
                <Divider/>
                <DialogContent>
                    <DialogContentText>Are you sure you want to submit your changes in {text}?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loading={loadingSubmit}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Yes
                    </LoadingButton>
                    {/* <Button variant="contained" onClick={handleSubmit}>
            Yes
          </Button> */}
                    <Button variant="outlined" onClick={handleClose} sx={{color: 'gray', borderColor: '#D3D3D3'}}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default SubmitDialog
